import React, {FC, useCallback, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
// custom
import NavbarAdmin from '../../../../components/navbar/Navbar.admin';
import PromotionAdminForm, { PromoFormData } from '../../../../components/forms/promotions/Promotion.admin.form';
import { IUserState } from '../../../../common/state/profile/user';
import { postPromotionAdmin, updatePromotionByIdAdmin } from '../../../../common/async/AsyncCalls';
import { getParsedEPOCDate } from '../../../../common/helpers/CommonUtil';
import { IPromotion, IPromotionState } from '../../../../common/state/promotions/promotion';
// custom

const PromotionUpdateAdmin : FC = () => {
    const history = useHistory();    
    // states    
    const selectedPromotion: IPromotion | undefined = useSelector(({promotion}: {promotion: IPromotionState}) => promotion.selected);
    const token: string = useSelector(({user} : {user: IUserState}) => user.token);
    // lifecycle
    const postNewPromotion = useCallback(async(formData: PromoFormData)=>{
        // console.log('Create new promotion record', formData);
        const promoId = selectedPromotion?.id ?? '';
        const start_date: number = getParsedEPOCDate(formData.startDate as string)
        const end_date: number = getParsedEPOCDate(formData.endDate as string);
        try {
            await updatePromotionByIdAdmin(token, promoId, {
                "promo_code": formData.promo_code,
                "description": formData.description,
                "discount": formData.discount,    
                "start_date": start_date,
                "end_date": end_date            
            });
            toast("Payment record updated successfully!");
            history.push({pathname: '/admin/promotions'});
        } catch (err) {
            console.log('Error updating promotion record: ', (err as Error).message);
        }
    },[token]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="flex flex-col items-start justify-start w-screen min-h-screen p-4 text-gray-700 bg-gray-200 lg:p-16 dark:bg-gray-800 dark:text-teal-400">
            <h2 className="mb-2 text-2xl text-gray-700 dark:text-teal-400">Update Payment Record</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300 dartext-base">                 
                Please note that the fields marked with * are required. Please note that promo code should be lowercase and snakecase format*               
            </p>
            <PromotionAdminForm defaultFormData={{
                promo_code: selectedPromotion?.promo_code?.toLowerCase()?? '',
                description: selectedPromotion?.description?? '',
                discount: selectedPromotion?.discount?? 0,
                startDate: null,
                endDate: null
            }}
            type = 'update' 
            onSubmit={postNewPromotion}/>
        </div>
    </React.Fragment>;
};

export default PromotionUpdateAdmin;